import { z } from 'zod'
import { maskEmail } from '@lib/utils/maskUtils'

export interface LoginInput {
  mcId?: string
  qr?: string
}

/* LoginType */
export const LoginType = {
  IM: 'IM',
  SOFT: 'API_HUB'
} as const

export const loginTypeUnion = z.union([z.literal(LoginType.IM), z.literal(LoginType.SOFT)])

export const imUserTagDto = z.object({
  value: z.string()
})

export const imUserRawDto = z.object({
  segments: z.array(z.string()).catch([]),
  tags: z.array(imUserTagDto).catch([])
})

export const customerDto = z.object({
  mcId: z.string(),
  imId: z.string(),
  name: z.string(),
  loyalty: z.boolean(),
  points: z.number(),
  loginType: loginTypeUnion.optional().default(LoginType.IM),
  imUserRaw: imUserRawDto.optional(),
  verified: z.boolean().optional().default(true),
  // only the masked email is kept, the original never reaches the store (nor the logs)
  email: z.string().optional().transform(maskEmail)
})

export type ImUserTag = z.infer<typeof imUserTagDto>
export type User = z.infer<typeof customerDto>

export interface OtpConfirmInput {
  otpCode: string
}

/** POST /customer/otp ok: datetime (ISO UTC) from which a new code can be requested */
export const otpRequestDto = z.object({
  nextValidationAt: z.string()
})

/** POST /customer/otp 400, must wait to get a new code */
export const otpWaitErrorDto = z.object({
  errors: z.object({ waitForNextCodeAttempt: z.string() }),
  nextValidationAt: z.string()
})

/** POST /customer/otp/confirm error body, `code` tells which controlled error it is */
export const OtpConfirmErrorCode = {
  INVALID: 'invalidOtpCode',
  EXPIRED: 'expiredCode',
  MAX_ATTEMPTS: 'maxAttemptsReached'
} as const

export const otpConfirmErrorDto = z.object({
  code: z.string()
})
